import dragula from 'dragula';

/**
 * Alpine.js directive for drag-and-drop sorting.
 *
 * Usage:
 *   <tbody x-drag-sort="keyringOrder">
 *     <tr data-id="101">
 *       <td><span data-drag-handle>☰</span></td>
 *       ...
 *     </tr>
 *   </tbody>
 *
 * The directive initializes Dragula on the element, restricting drags to
 * elements (or children of elements) with the `data-drag-handle` attribute.
 * On drop, it reads `data-id` from each child in DOM order and sets the
 * named Alpine property to the resulting array of ID strings.
 */
export default function (Alpine) {
  Alpine.directive('drag-sort', (el, { expression }, { evaluate, cleanup }) => {
    const drake = dragula([el], {
      invalid: (_el, handle) => !handle.closest('[data-drag-handle]'),
      moves: (el) => el.hasAttribute('data-id'),
    });

    // Pause Alpine's MutationObserver during drags so it doesn't try to
    // re-init moved elements before they have a valid scope chain.
    drake.on('drag', () => Alpine.deferMutations());
    drake.on('dragend', () => Alpine.flushAndStopDeferringMutations());

    drake.on('drop', () => {
      const ids = [...el.children].map((child) => child.dataset.id).filter(Boolean);
      evaluate(`${expression} = [${ids.map((id) => `'${id}'`).join(',')}]`);
    });

    cleanup(() => drake.destroy());
  });
}
